import { createFeatureSelector, createSelector } from '@ngrx/store';

import { USER_HISTORY_FEATURE_KEY, userHistoryAdapter, UserHistoryState } from './history.reducer';

const { selectAll } = userHistoryAdapter.getSelectors();

export const getUserHistoryState = createFeatureSelector<UserHistoryState>(USER_HISTORY_FEATURE_KEY);
export const getUserHistoryEntries = createSelector(getUserHistoryState, (state: UserHistoryState) => selectAll(state));
